var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHousing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0862 19.9042H29.021V45.0001H46.0862V19.9042Z",
    fill: "#1A565F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.021 14.0537L14.9673 0L0.913574 14.0537V45H29.021V14.0537Z",
    fill: "#78E183"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94434 20.908H20.9904V16.8927H8.94434V20.908ZM8.94434 28.9387H20.9904V24.9234H8.94434V28.9387Z",
    fill: "#1A565F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9519 36.9695H18.9826V45.0002H10.9519V36.9695Z",
    fill: "#1A565F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousing);
export default __webpack_public_path__ + "static/media/housing.2e61c8f317d7824b359cd8f1239ed7b2.svg";
export { ForwardRef as ReactComponent };